import React from "react";
import PropTypes from "prop-types";

import { MenuItem } from '@mui/material';

const MenuItemUI = ({ className, ...props }) => {
	return (
		<MenuItem
			className={ className }
			disableRipple
			{ ...props }
		/>
	);
};

MenuItemUI.propTypes = {
	className: PropTypes.string,
};

export default MenuItemUI;
